import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import axiosInstance from "../../utils/AxiosConfig";
import ProductCard from "../Cards/Card";
import { cleanNumber, getProductImage } from "../../utils/productPresentation";
import { getCartRequest, insertCartRequest } from "../../Containers/Home/Home-slice";
import { showSuccess } from "../../utils/Toast";
import { useInitialData } from "../../SSR/InitialDataContext";

function SearchResults({ insertCartRequest, getCartRequest, addcartdata }) {
  const [params] = useSearchParams();
  const query = (params.get("q") || "").trim();
  const initialData = useInitialData();
  const initialProducts = initialData?.searchPage?.query === query
    && initialData?.url?.split("?")[0] === "/search"
    ? initialData.searchPage.products
    : null;
  const [products, setProducts] = useState(() =>
    Array.isArray(initialProducts) ? initialProducts : [],
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sortBy, setSortBy] = useState("newest");

  useEffect(() => {
    if (!query) {
      setProducts([]);
      return undefined;
    }
    let active = true;
    setLoading(true);
    setError("");
    axiosInstance.get("searchProducts", { params: { q: query } })
      .then((response) => {
        if (active) setProducts(Array.isArray(response.data?.results) ? response.data.results : []);
      })
      .catch(() => {
        if (active) setError("Search is unavailable right now. Please try again.");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [query]);

  useEffect(() => {
    if (addcartdata?.success) {
      showSuccess(addcartdata.message);
      getCartRequest();
    }
  }, [addcartdata, getCartRequest]);

  const sortedProducts = useMemo(() => {
    if (sortBy === "newest") return products;
    return [...products].sort((a, b) => {
      const difference = cleanNumber(a.price) - cleanNumber(b.price);
      return sortBy === "priceLow" ? difference : -difference;
    });
  }, [products, sortBy]);

  return (
    <main className="cp-page search-results-page">
      <div className="cp-shell">
        <div className="cp-mobile-heading search-results-heading">
          <h1>Search results</h1>
          <p>{query ? `${sortedProducts.length} results for "${query}"` : "Enter a product or brand to search"}</p>
        </div>
        <div className="search-desktop-heading">
          <h1>Search results</h1>
          <p>{query ? `${sortedProducts.length} results for "${query}"` : "Enter a product or brand to search"}</p>
        </div>
        {sortedProducts.length > 0 && (
          <label className="search-results-sort">
            Sort by
            <select value={sortBy} onChange={(event) => setSortBy(event.target.value)}>
              <option value="newest">Relevance</option>
              <option value="priceLow">Price: low to high</option>
              <option value="priceHigh">Price: high to low</option>
            </select>
          </label>
        )}
        {loading ? <p role="status">Searching products...</p> : error ? <p role="alert">{error}</p> : query && !sortedProducts.length ? <p>No products found.</p> : null}
        <div className="cp-products-grid">
          {sortedProducts.map((product) => {
            const basePrice = cleanNumber(product.price);
            const discount = cleanNumber(product.discount);
            return (
              <ProductCard
                key={product.id}
                id={product.id}
                title={product.name}
                imageUrl={getProductImage(product)}
                price={discount > 0 ? basePrice * (1 - discount / 100) : basePrice}
                oldPrice={discount > 0 ? basePrice : null}
                discount={discount}
                stock_quantity={product.stock_quantity}
                status={product.status}
                item={product}
                onAdd={() => insertCartRequest({ product_id: product.id, quantity: 1, price: basePrice, discount, attributes: product.attributes || {} })}
              />
            );
          })}
        </div>
      </div>
    </main>
  );
}

export default connect(
  (state) => ({ addcartdata: state.Home.Cartdata }),
  (dispatch) => ({
    insertCartRequest: (payload) => dispatch(insertCartRequest(payload)),
    getCartRequest: () => dispatch(getCartRequest()),
  }),
)(SearchResults);
